// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateGuestReducer extends Reducer
{
	public static reducerName: string = "UpdateGuest";
	public static call(_nickname: string, _selectedElementId: number, _positionX: number, _positionY: number) {
		this.getReducer().call(_nickname, _selectedElementId, _positionX, _positionY);
	}

	public call(_nickname: string, _selectedElementId: number, _positionX: number, _positionY: number) {
		const serializer = this.client.getSerializer();
		let _nicknameType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_nicknameType, _nickname);
		let _selectedElementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_selectedElementIdType, _selectedElementId);
		let _positionXType = AlgebraicType.createPrimitiveType(BuiltinType.Type.I32);
		serializer.write(_positionXType, _positionX);
		let _positionYType = AlgebraicType.createPrimitiveType(BuiltinType.Type.I32);
		serializer.write(_positionYType, _positionY);
		this.client.call("UpdateGuest", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let nicknameType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let nicknameValue = AlgebraicValue.deserialize(nicknameType, adapter.next())
		let nickname = nicknameValue.asString();
		let selectedElementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let selectedElementIdValue = AlgebraicValue.deserialize(selectedElementIdType, adapter.next())
		let selectedElementId = selectedElementIdValue.asNumber();
		let positionXType = AlgebraicType.createPrimitiveType(BuiltinType.Type.I32);
		let positionXValue = AlgebraicValue.deserialize(positionXType, adapter.next())
		let positionX = positionXValue.asNumber();
		let positionYType = AlgebraicType.createPrimitiveType(BuiltinType.Type.I32);
		let positionYValue = AlgebraicValue.deserialize(positionYType, adapter.next())
		let positionY = positionYValue.asNumber();
		return [nickname, selectedElementId, positionX, positionY];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _nickname: string, _selectedElementId: number, _positionX: number, _positionY: number) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _nickname: string, _selectedElementId: number, _positionX: number, _positionY: number) => void)
	{
		this.client.on("reducer:UpdateGuest", callback);
	}
}


export default UpdateGuestReducer
